export const ROOT = 'common/validateAccess';

export const FETCH_VALIDATE_ACCESS_REQUEST = `${ROOT}/FETCH_VALIDATE_ACCESS_REQUEST`;
export const FETCH_VALIDATE_ACCESS_FAILURE = `${ROOT}/FETCH_VALIDATE_ACCESS_FAILURE`;
export const FETCH_VALIDATE_ACCESS_SUCCESS = `${ROOT}/FETCH_VALIDATE_ACCESS_SUCCESS`;

export const CLEAR_VALIDATE_ACCESS_DATA = `${ROOT}/CLEAR_VALIDATE_ACCESS_DATA`;
